import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ProfilePage} from "../profile/profile";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the ProfilePasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-profile-password',
    templateUrl: 'profile-password.html',
})
export class ProfilePasswordPage {
    errors: {};
    loading: boolean;
    account: object;
    current_password: string;
    password: string;
    password_confirmation: string;

    constructor(public navCtrl: NavController, public navParams: NavParams, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        this.account = navParams.get('account');
    }

    update() {
        this.loading = true;

        this.http.post('/password/reset', {
            // @ts-ignore
            id: this.account.id,
            current_password: this.current_password,
            password: this.password,
            password_confirmation: this.password_confirmation,
        }).subscribe(
            data => {
                this.password = null;
                this.current_password = null;
                this.password_confirmation = null;

                this.errors = {};
                this.loading = false;

                // Redirect to the user profile page
                this.navCtrl.pop();
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            })
    }

}



// WEBPACK FOOTER //
// ./src/pages/profile-password/profile-password.ts